import React, {useState, useEffect, useContext, useRef} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
// import ComSingleRa from './ComSingleRa';




function Resume(){
  const [state, actions] = useContext(UserContext);
  // const [resume, setResume] = useState(null)
  const inputFile = useRef(null) 

  let user = JSON.parse(String(localStorage.getItem('user')))
  let header = {}

  if(user){
    header = {Authorization: `JWT ${user.token}`}
  } else{
    header = {}
  }
  
  const [selectedFile, setSelectedFile] = useState();
	const [isFilePicked, setIsFilePicked] = useState(false);

  const [fileList, setFileList] = useState()
  // let apilink = ''

  // if(localStorage.getItem("is_headhunter") === "true") apilink = "/api/rahh/"
  // else if (localStorage.getItem("is_recruiter") === "true") apilink = "/api/ra/"

  // function fetchDelete(id){
  //   fetch(state.awslink + apilink, {
  //     method: 'DELETE',
  //     headers: header,
  //     body:JSON.stringify({
  //       "id": id
  //     })
  //     })
  //     .then(response => response.json())
  //     .then(json=>{
  //       console.log("deleted")
  //     })
  // }
  

  useEffect(()=>{
    async function fetchResumeData(){
      fetch(state.awslink + "/api/resume/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        // setResume(json)
        let newobj = [];
        if(json.length){
          json.map((item, index)=>{
            newobj.push({"value": index, "label": index, "id": item.id})
            return null
          })
        }
        actions.setResume(json)

      })
    }

    async function fetchFileList(){
      fetch(state.awslink + "/api/file/", {
        method: 'GET',
        headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        // setResume(json)
        setFileList(json)
        // let newobj = [];
        // if(json.length){
        //   json.map((item, index)=>{
        //     newobj.push({"value": index, "label": index, "id": item.id})
        //   })
        // }
        // actions.setResume(json)

      })
    }

    fetchResumeData();
    fetchFileList();
    
  }, [])

  // console.log(resume)
  
  // if(ralist === null){
  //   console.log("fetch2")
  //   if(state.token != undefined)
  //     fetchRalist();
  // }
  const changeHandler = (event) => {
		setSelectedFile(event.target.files[0]);
		setIsFilePicked(true);
	};
  const handleSubmission = () => {
		const formData = new FormData();

		formData.append('file', selectedFile);

    console.log(formData)

		fetch(
			state.awslink + "/api/file/",
			{
				method: 'POST',
        headers: header,
				body: formData,
			}
		)
			.then((response) => response.json())
			.then((result) => {
				console.log('Success:', result);
        // setSelectedFile()
        window.location.reload()
			})
			.catch((error) => {
				console.error('Error:', error);
			});
    
	};
  const onButtonClick = () => {
    // `current` points to the mounted file input element
   inputFile.current.click();
   
  };

  function fetchDownload(filename){
    fetch(
			state.awslink + "/api/file/",
			{
				method: 'PUT',
        headers: header,
				body: JSON.stringify({
          "filename": filename
        }),
			}
		)
			.then((response) => response.blob())
			// .then((result) => {
			// 	console.log('Success:', result);
      //   // setSelectedFile()
      //   // window.location.reload()
			// })
      .then(blob => {
        // console.log(blob)
        const href = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.setAttribute('download', filename + '.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
      .catch(err => console.error(err));
  }

  return(
    <>
    
      <Wrapper>
        <RaWrapper>
          <CardWrapper>
          {state.resume &&
            <CardAdd style={{justifyContent: 'center', alignItems: 'center'}}> 
              <div>
                <Link to={'/resume/edit/add'}>
                  <div>+</div></Link>
              </div>
            </CardAdd>
          }

          {/* <CardFile style={{justifyContent: 'center', alignItems: 'center'}}>
            <div>
              
              {isFilePicked ? 
              <>
              <p>Filename: {selectedFile.name}</p>
              <button className={'submit'} onClick={handleSubmission}>올리기</button>
              </>
              :
                <>
                  <input 
                  type="file" 
                  name="file" 
                  ref={inputFile} 
                  onChange={changeHandler} 
                  style={{ display: "none" }}/>
                  <button className={'open'} onClick={onButtonClick}>OPEN</button>
                </>
              }
            </div>
          </CardFile> */}
          
          {state.resume ? 
            state.resume.length && 
            state.resume.map((item, index)=>{
              console.log(index, item)
              return(
              <Card>
                <div>
                {/* <Delete onClick={()=> fetchDelete(item.id)}>X</Delete> */}
                <Link to={'/resume/edit/'+ item.id}> 
                  <div>
                    <div className={'qu-title'}>{item.title}</div>
                    <div className={'qu-add'}>{item.created.split('T')[0]}</div>
                  </div>
                </Link>
                
                {/* <div>{item.category}</div>
                <div>{item.status}</div>
                <div>{item.active}</div>
                
                <div>{item.salary}</div>
                <div>{item.workyears}</div>
                
                <div>{item.views}</div> */}
                </div>
              </Card>)
            })
          :null}

          {/* {fileList ? 
            fileList.length && 
            fileList.map((item, index)=>{
              console.log(index, item)
              return(
              <Card onClick={()=>fetchDownload(item.Key.split('/')[item.Key.split('/').length-1])}>
                
                
                <div>
                <Link>
                    <div>
                      <div className={'qu-title'}>{item.Key.split('/')[item.Key.split('/').length-1]}</div>
                      <div className={'qu-add'}>{item.LastModified.split('T')[0]}</div>
                      <div className={'qu-add'}>{(item.Size/1024/1024).toFixed(1)} MB</div>
                    </div>
                  </Link>
                </div>
                
              </Card>)
            })
          :null} */}
          
          

          </CardWrapper>
        </RaWrapper>
      </Wrapper>   
      
    </>
  )
}

const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  margin-top: 45px;
  display: block;
  position: relative;
`

const RaWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: block;
  margin: 0 auto;
  background-color: whitesmoke;
`

const CardWrapper = styled.ul`
  padding: 0;
  content: " ";
  display: table;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  list-style: none;
  list-style-position: outside;

  margin: -10px;
  margin-top: 55px;
  width: calc(100% + 20px);
`

const CardAdd = styled.li`
  width: 25%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  display: inline-block;
  /* padding-bottom: 56.25%; */
  height: calc(25vw * .6);
  min-height: 200px;
  padding: 10px;
  float: left;
  vertical-align: top;
  
  @media (max-width: 768px){
    width: 50%;
  }

  >div{
    border: 0.5px solid rgba(0,0,0,0.2);
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 5px;

    >a{
      display: flex;
      justify-content: center;
      align-items: center;
      
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;

      text-decoration: none;
    
      >div{
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background-color: rgba(253,134,18, 0.8);
        /* background-color: rgba(0,0,0, 0.2); */

        color: white;

        border-radius: 50px;
        width: 70px;
        height: 70px;
      }
    }
  }
`

const CardFile = styled.li`
  width: 25%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  display: inline-block;
  /* padding-bottom: 56.25%; */
  height: calc(25vw * .6);
  min-height: 200px;
  padding: 10px;
  float: left;
  vertical-align: top;
  
  @media (max-width: 768px){
    width: 50%;
  }

  >div{
    border: 0.5px solid rgba(0,0,0,0.2);
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .submit{
      cursor: pointer;
      border: none;
      padding: 5px;
      background-color: rgba(253,134,18, 0.8);
      color: white;

      width: 50px;
      height: 20px;
    }
    .open{
      cursor: pointer;
      border: none;
      padding: 5px;
      background-color: rgba(253,134,18, 0.8);
      background-color: rgba(0,0,0, 0.2);

      color: white;

      border-radius: 50px;
      width: 70px;
      height: 70px;
    }
  }
`


const Card = styled.li`
  width: 25%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  display: inline-block;
  /* padding-bottom: 56.25%; */
  height: calc(25vw * .6);
  min-height: 200px;
  padding: 10px;
  float: left;
  vertical-align: top;
  
  @media (max-width: 768px){
    width: 50%;
  }

  >div{
    border: 0.5px solid rgba(0,0,0,0.2);
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 5px;
    >a{
    display: block;
    
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;

    text-decoration: none;
    >header{
      height: 60%;
      background-position-x:50%;
      background-position-y:50%;
      background-size: cover;
      
    }
    >div{
      cursor: pointer;
      color: black;
      padding: 10px;
      
      >div{
        text-align: left;
      }
    }
  }
  }
  
`
// const Delete = styled.div`
//   position: absolute;
//   width: 20px;
//   height: 20px;
//   right: 0px;
//   display:flex;
//   justify-content: center;
//   align-items:center;

//   z-index:1;
// `
export default Resume